import React from "react";
import { CloseIcon } from "@/assets/icons";
import cls from "./styles.module.scss";
import type { Trigger } from "@/analytics";

interface CloseBtnProps {
  onclose: () => void;
  trigger?: Trigger;
}

export const CloseBtn = ({ onclose, trigger }: CloseBtnProps) => {
  return (
    <button
      type="button"
      onClick={onclose}
      className={cls.closeBtn}
      data-trigger={trigger ?? ""}
    >
      <CloseIcon />
    </button>
  );
};
